// extracted by mini-css-extract-plugin
export default {"invoiceModalHolder":"FekGQs1Bdqz+wzkqjmW1TA==","amountTooltip":"rSX6ob+4YtZE+-5WuTNF1A=="};